export * from "-!../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./TabResetPassword.vue?vue&type=template&id=6ee456ae&scoped=true&"


//////////////////
// WEBPACK FOOTER
// ./modules/Home/views/src/components/Settings/TabResetPassword.vue?vue&type=template&id=6ee456ae&scoped=true&
// module id = 928
// module chunks = 0